import PerformanceCard from 'components/PerformanceCard'
import QuizTopicCard from 'components/QuizTopicCard'
import { useState } from 'react'
import { Route, Routes } from 'react-router'
import { TOPICS } from 'utils'
import QuizDetailPage from './QuizDetailPage'
import { useQuery } from '@tanstack/react-query'
import HTTPClient from 'services/HTTPClient'
import AuthService from 'services/AuthService'
import Spinner from 'components/Spinner'

type Props = {}

const useQuizConfig = (grade) => {
    const url = `/api/quiz-configs?filters[grade][$eq]=${grade}`;
    return useQuery(['quizConfig', grade], async () => {
        let response = await HTTPClient.get().getJSONResult(url)
        let lookup = {}
        response["data"][0].config.forEach(c => {
            lookup[c.topic] = c.is_enabled
        })
        return lookup
    });
};


function QuizPage({ }: Props) {
    const [scores, setScores] = useState({})
    const { data: quizConfig, isLoading, error } = useQuizConfig(AuthService.getGrade());
    if (isLoading || error) {
        return <div className="center">
            <Spinner className='mt-6' />
        </div>
    }

    console.log("Rendering Quiz page", quizConfig, isLoading, error)
    return (
        <div className='px-5 py-5' style={{ height: "100vh", overflow: "auto" }}>
            <h3 className='is-size-3 mb-5'>
                <strong>Performance</strong>
            </h3>
            <PerformanceCard
                scores={scores}
            />
            <h3 className='is-size-3 mb-5'>
                <strong>Quizzes</strong>
            </h3>
            <div className="quiz-card pb-6 mx-0 px-0">
                {TOPICS.map(t => {
                    if (!quizConfig![t.topic]) {
                        return null
                    }
                    return <QuizTopicCard
                        key={t.topic}
                        topic={t}
                        onPercentObtained={(topic, score) => {
                            console.log("settings topic score", topic, score)
                            if (topic !== "Open Conversations") {
                                setScores(scores => ({
                                    ...scores,
                                    [topic]: score,
                                }))
                            }
                        }} />
                })}
            </div>
        </div>
    )
}

export default function QuizRoute() {
    console.log("Quiz Route")
    return <Routes>
        <Route path='/quiz/:topic' element={<QuizDetailPage />} />
        <Route index path='/' element={<QuizPage />} />
    </Routes>
}